import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Truck, Globe, Package, Building2, CheckCircle, Calculator, Star } from "lucide-react";

const ServicesPage = () => {
  const services = [
    { icon: Truck, title: "Mensajería Nacional", description: "Envíos a cualquier parte de México con las mejores tarifas.", features: ["Cobertura en todo México", "Rastreo en tiempo real", "Seguro incluido"] },
    { icon: Globe, title: "Envíos Internacionales", description: "Conectamos tu negocio con el mundo. Enviamos a más de 200 países.", features: ["Más de 200 destinos", "Documentación incluida", "Asesoría aduanal"] },
    { icon: Package, title: "Empaque Especializado", description: "Protegemos tus artículos más delicados con técnicas profesionales.", features: ["Artículos frágiles", "Obras de arte", "Electrónicos"] },
    { icon: Building2, title: "Mudanzas", description: "Servicio completo de mudanza residencial y comercial.", features: ["Casas y oficinas", "Empaque profesional", "Servicio puerta a puerta"] },
  ];

  return (
    <div className="min-h-screen pt-24 pb-16 bg-[#FAF9F6]" data-testid="services-page">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-16">
          <span className="font-mono text-xs font-bold text-[#F57C00] tracking-[0.2em] uppercase">NUESTROS SERVICIOS</span>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-black text-[#5D4037] mt-4">Servicios integrales de logística</h1>
          <p className="text-stone-600 text-lg mt-4 max-w-2xl mx-auto">Contamos con las alianzas, materiales y experiencia para ayudarte.</p>
        </div>
        <div className="grid md:grid-cols-2 gap-8">
          {services.map((service, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }} className="bento-card p-8" data-testid={`service-${i}`}>
              <div className="w-16 h-16 bg-[#2E7D32] rounded-2xl flex items-center justify-center mb-6"><service.icon size={32} className="text-white" /></div>
              <h3 className="text-2xl font-bold text-[#5D4037] mb-4">{service.title}</h3>
              <p className="text-stone-600 mb-6">{service.description}</p>
              <ul className="space-y-3">{service.features.map((feature, j) => (<li key={j} className="flex items-center gap-3"><CheckCircle size={20} className="text-[#4CAF50]" /><span className="text-stone-700">{feature}</span></li>))}</ul>
            </motion.div>
          ))}
        </div>
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="mt-16 bento-card p-8 md:p-12 bg-gradient-to-br from-[#F57C00] to-[#FF9800] text-white" data-testid="loyalty-program">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <span className="font-mono text-xs text-white/70 tracking-widest">PROGRAMA DE LEALTAD</span>
              <h3 className="text-3xl font-black mt-4">10 + 1 Gratis</h3>
              <p className="text-white/80 mt-4">Por cada 10 envíos realizados, recibes gratis un envío nacional de menos de 1kg.</p>
            </div>
            <div className="flex justify-center">
              <div className="flex -space-x-2">
                {[...Array(10)].map((_, i) => (<div key={i} className="w-12 h-12 rounded-full bg-white/20 border-2 border-white flex items-center justify-center font-bold">{i + 1}</div>))}
                <div className="w-12 h-12 rounded-full bg-white text-[#F57C00] border-2 border-white flex items-center justify-center font-bold">+1</div>
              </div>
            </div>
          </div>
        </motion.div>
        <div className="mt-12 text-center">
          <Link to="/cotizar" className="btn-primary inline-flex items-center gap-2" data-testid="services-cotizar-btn"><Calculator size={20} /> Cotizar ahora</Link>
        </div>
      </div>
    </div>
  );
};

export default ServicesPage;
